unit View.ErrorPage;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls,

  XData.Web.Connection, WEBLib.StdCtrls;

type
  TFViewErrorPage = class(TForm)
    lbTitle: TLabel;
    lbMessage: TLabel;
  public
    class procedure Display(pErro, pTitulo: string);
    class procedure DisplayConnectionError(AError: TXDataWebConnectionError);
  protected procedure LoadDFMValues; override; end;

var
  FViewErrorPage: TFViewErrorPage;

implementation

{$R *.dfm}

{ TFViewErrorPage }

class procedure TFViewErrorPage.Display(pErro, pTitulo: string);

  procedure AfterCreateProc(AForm: TObject);
  begin
    TFViewErrorPage(AForm).lbMessage.Caption := pErro;
    TFViewErrorPage(AForm).lbTitle.Caption := pTitulo;
  end;

begin
  if Assigned(FViewErrorPage) then
    FViewErrorPage.Free;
  FViewErrorPage := TFViewErrorPage.CreateNew(@AfterCreateProc);
end;

class procedure TFViewErrorPage.DisplayConnectionError(
  AError: TXDataWebConnectionError);
var
  lMensagem,
  lTitulo : string;
begin
  if Pos('error connecting to xdata server', AError.ErrorMessage.ToLower) > 0 then
  begin
    lTitulo := 'Não foi possível conectar ao servidor!';
    lMensagem := 'Tente novamente mais tarde.';
  end
  else
  begin
    lTitulo := 'Ocorreu um erro inesperado!';
    lMensagem := AError.ErrorMessage + sLineBreak + 'Tente novamente mais tarde.';
  end;

  Display(lMensagem, lTitulo);
end;

procedure TFViewErrorPage.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbTitle := TLabel.Create('hero-msg');
  lbMessage := TLabel.Create('lblMensagem');

  lbTitle.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  try
    Name := 'FViewErrorPage';
    Width := 534;
    Height := 426;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    lbTitle.SetParentComponent(Self);
    lbTitle.Name := 'lbTitle';
    lbTitle.Left := 24;
    lbTitle.Top := 24;
    lbTitle.Width := 128;
    lbTitle.Height := 13;
    lbTitle.Caption := 'Oops... an error occurred!';
    lbTitle.HeightPercent := 100.000000000000000000;
    lbTitle.Transparent := False;
    lbTitle.WidthPercent := 100.000000000000000000;
    lbMessage.SetParentComponent(Self);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 24;
    lbMessage.Top := 56;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.HeightPercent := 100.000000000000000000;
    lbMessage.Transparent := False;
    lbMessage.WidthPercent := 100.000000000000000000;
  finally
    lbTitle.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
  end;
end;

end.
